import React, {useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {getGeneratedRoute, RouteEnumFinal} from "../../../Config/RouteEnum";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash, faPhone, faPlus} from "@fortawesome/free-solid-svg-icons";
import {Modal} from "react-bootstrap";
import ButtonPrimary from "../../Elements/ButtonPrimary";
import Agent from "../../../Network/Agent";
import {BASE_URL} from "../../../Config/SharedConfig";
import {useQueryClient} from "@tanstack/react-query";
import {getStoreName} from "../../Utils/getStoreName";
import {useDispatch, useSelector} from "react-redux";
import {updateIsInCustomerMode} from "../../../features/store/storeSlice";

const FloatingButtons = () => {
    const storeUsername = getStoreName()
    const [isModalMenuOpen, setIsModalMenuOpen] = useState(false)
    const [isModalCategoryOpen, setIsModalCategoryOpen] = useState(false)
    const [isModalSocialsOpen, setIsModalSocialsOpen] = useState(false)
    const [categoryTitle, setCategoryTitle] = useState("")
    const [categoryError, setCategoryError] = useState("")
    const [isLoadingSubmitCategory, setIsLoadingSubmitCategory] = useState(false)

    const {isInCustomerMode, store} = useSelector(state => state.store)
    const dispatch = useDispatch()
    const theme = store?.theme

    const [socials, setSocials] = useState([])

    const queryClient = useQueryClient()
    const navigate = useNavigate()

    const submitCreateCategory = (e) => {
        e.preventDefault()
        setIsLoadingSubmitCategory(true)
        Agent.Category.create(storeUsername , categoryTitle)
            .then(response => {
                console.log(response)
                const {category} = response.data.result
                setIsModalMenuOpen(false)
                setIsModalCategoryOpen(false)
                setIsLoadingSubmitCategory(false)
                setCategoryError("")
                queryClient.invalidateQueries({
                    queryKey: ['categories', storeUsername]
                })
                navigate(getGeneratedRoute(RouteEnumFinal.MAIN_URL_GENERATE, category.code))
            })
            .catch(error => {
                setIsLoadingSubmitCategory(false)
                setCategoryError(error.response.data.message)
            })
    }

    useEffect(() => {
        Agent.Store.getSocialListForUser(storeUsername)
            .then(response => {
                const socials = response.data.result.socials
                setSocials(socials)
            })
            .catch(error => {
                console.log(error)
            })
    }, []);

    return (
        <>
            <section className='floating-action-btn left' style={{bottom: (store?.isOwner && !isInCustomerMode) ? "64px" : "20px"}}>
                {
                     (store?.isOwner && !isInCustomerMode) &&
                        <div className='each-fa-btn cursor-pointer'
                             onClick={() => dispatch(updateIsInCustomerMode(!isInCustomerMode))}
                             style={{backgroundColor: theme?.primaryColor}}>
                            <FontAwesomeIcon icon={faEye} style={{fontSize: '20px', color: theme?.primaryTextColor}}/>
                        </div>
                }
                {
                    (store?.isOwner && isInCustomerMode) &&
                        <div className='each-fa-btn cursor-pointer'
                             onClick={() => dispatch(updateIsInCustomerMode(!isInCustomerMode))}
                             style={{backgroundColor: theme?.primaryColor}}>
                            <FontAwesomeIcon icon={faEyeSlash} style={{fontSize: '20px', color: theme?.primaryTextColor}}/>
                        </div>
                }
                {
                    (store?.isOwner && !isInCustomerMode) &&
                    <div className='each-fa-btn mt-custom-4'
                         style={{backgroundColor: theme?.primaryColor}}
                         onClick={() => setIsModalMenuOpen(m => !m)}>
                        <FontAwesomeIcon icon={faPlus} style={{fontSize: '20px', color: theme?.primaryTextColor}}/>
                        </div>
                }
                {
                    ((!store?.isOwner || isInCustomerMode) && (!!socials.length)) &&
                        <div className='each-fa-btn mt-custom-4'
                             onClick={() => setIsModalSocialsOpen(m => !m)}
                             style={{backgroundColor: theme?.primaryColor}}>
                            <FontAwesomeIcon icon={faPhone} style={{fontSize: '20px', color: theme?.primaryTextColor}}/>
                        </div>
                }
            </section>

            <Modal className='bottom-sheet fade in'
                   show={isModalMenuOpen}
                   onHide={() => setIsModalMenuOpen(m => !m)}>
                <Modal.Body>
                    <div className='d-flex justify-content-center pt-10 pb-10'
                         onClick={() => setIsModalMenuOpen(m => !m)}>
                        <div className='bottom-sheet-close-line btn p-0 '/>
                    </div>

                    <div className='d-flex align-items-center mt-20 cursor-pointer'
                         onClick={() => setIsModalCategoryOpen(m => !m)}>
                        <div className='icon-cnt-round-44 bg-grass'>
                            <div className='img-cnt-24'>
                                <img src={"/assets/images/vectors/category_line_white.svg"} alt="add category"/>
                            </div>
                        </div>
                        <div className='mobile-h5 cl-black mr-20'>
                            ایجاد دسته بندی جدید
                        </div>
                    </div>
                    <Link to={getGeneratedRoute(RouteEnumFinal.PRODUCT_ADD_URL_GENERATE, storeUsername)}
                          className='d-flex align-items-center td-none mt-20'>
                        <div className='icon-cnt-round-44 bg-yellow'>
                            <div className='img-cnt-24'>
                                <img src={"/assets/images/vectors/add_product_line_white.svg"} alt="add product"/>
                            </div>
                        </div>
                        <div className='mobile-h5 cl-black mr-20'>
                            ایجاد محصول جدید
                        </div>
                    </Link>

                </Modal.Body>
            </Modal>

            <Modal className='bottom-sheet fade in'
                   show={isModalCategoryOpen}
                   onHide={() => setIsModalCategoryOpen(m => !m)}>
                <Modal.Body>
                    <div className='d-flex justify-content-center pt-10 pb-10'
                         onClick={() => setIsModalCategoryOpen(m => !m)}>
                        <div className='bottom-sheet-close-line btn p-0 '/>
                    </div>

                    <div className='mobile-h5 cl-black mt-20'>
                        ایجاد دسته بندی جدید
                    </div>
                    <div className='mobile-subtitle-regular cl-subtitle mt-custom-4'>
                        برای ساختن دسته بندی جدید لطفا یک عنوان برای آن وارد کنید :
                    </div>

                    <form onSubmit={(e) => submitCreateCategory(e)}>
                        <div className='form-group-input-primary mt-32'>
                            <label className="form-group-label">
                                <input type="text"
                                       autoComplete="off"
                                       className={'form-group-input ' + (categoryError.length ? "hasError" : "")}
                                       value={categoryTitle}
                                       onChange={(e) => setCategoryTitle(e.target.value)}
                                       placeholder='عنوان دسته بندی : لباس مردانه'/>
                                <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                    {
                                        categoryError
                                    }
                                </div>
                            </label>
                        </div>
                        <div className='mt-32'>
                            <ButtonPrimary text='ثبت'
                                           mode='dark-mode'
                                           isLoading={isLoadingSubmitCategory}/>
                        </div>
                    </form>

                </Modal.Body>
            </Modal>

            <Modal className='bottom-sheet fade in'
                   show={isModalSocialsOpen}
                   onHide={() => setIsModalSocialsOpen(m => !m)}>
                <Modal.Body>
                    <div className='d-flex justify-content-center pt-10 pb-10'
                         onClick={() => setIsModalSocialsOpen(m => !m)}>
                        <div className='bottom-sheet-close-line btn p-0 ' />
                    </div>

                    <div className='container mt-20'>
                        <div className='row g-3'>
                            {
                                socials.map(social => {
                                    return(
                                        <div className='col-3' key={social.code}>
                                            <a href={social.originalUrl}
                                               target='_blank'
                                               className='td-none d-block text-center'>
                                                <div className='d-flex justify-content-center'>
                                                    <div className='img-cnt-36'>
                                                        <img src={BASE_URL+social.icon} alt={social.title}/>
                                                    </div>
                                                </div>
                                                <div className='mobile-subtitle-regular cl-black mt-8'>
                                                    { social.title }
                                                </div>
                                            </a>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default FloatingButtons